import axios from '@/util/request'

export default {
  queryPage: function (param) {
    let url = '/api/v1/manage/club/story/queryPage?' + Object.keys(param).map(k => `${k}=${param[k]}`).join('&')
    return axios.get(url)
  },
  get: function (id) {
    let url = '/api/v1/manage/club/story/getForEdit?id=' + id
    return axios.get(url)
  },
  add: function (data) {
    let url = '/api/v1/manage/club/story/add'
    return axios.post(url, data)
  },
  update: function (data) {
    let url = '/api/v1/manage/club/story/update'
    return axios.post(url, data)
  },
  updateStatus: function (data) {
    let url = '/api/v1/manage/club/story/updateStatus'
    return axios.post(url, data)
  },
  delBanner: function (fileName) {
    let url = '/api/v1/manage/club/banner/delete'
    return axios.post(url, {
      fileName: fileName
    })
  }
  // del: function (id) {
  //   let url = '/api/v1/club/story/delete?id=' + id
  //   return axios.post(url)
  // }
}
